import React, { useState } from 'react'
import CollectionCentersList from './CollectionCentersList'
import CollectionCentersForm from './CollectionCentersForm';

const CollectionCenters= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
	

  return (
    <>
      {fromIsShown ? (
          <CollectionCentersForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <CollectionCentersList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default CollectionCenters